// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-kmYs5UI1 fl","box":"box-1qWxrgXr"};